var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-info-callback-page"},[_c('van-button',{staticClass:"back-btn",attrs:{"type":"info"},on:{"click":_vm.goToApp}},[_vm._v("返回")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }